/* eslint-disable no-console */
/**
 * Environment Variables Checker
 * 
 * This utility helps debug environment variable issues in React applications.
 */

// Function to check if environment variables are properly loaded
export const checkEnvironmentVariables = () => {
  const variables = {
    REACT_APP_OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    NODE_ENV: process.env.NODE_ENV};

  const results = {
    variables: {},
    issues: []};

  // Check each variable
  Object.keys(variables).forEach(key => {
    const value = variables[key];
    const isSet = !!value;
    const isPlaceholder = value === 'your_openai_api_key_here' || value === 'your_actual_api_key_here';
    
    results.variables[key] = {
      isSet,
      length: value ? value.length : 0,
      isPlaceholder,
      preview: value ? `${value.substring(0, 5)}...${value.substring(value.length - 5)}` : 'Not set'};

    // Add issues if found
    if (!isSet && key !== 'NODE_ENV') {
      results.issues.push(`${key} is not set`);
    } else if (isPlaceholder) {
      results.issues.push(`${key} is still set to a placeholder value`);
    }
  });

  return results;
};

// Function to log environment variable status to console
export const logEnvironmentStatus = () => {
  const results = checkEnvironmentVariables();
  
  console.group('Environment Variables Status');
  
  Object.keys(results.variables).forEach(key => {
    const variable = results.variables[key];
    if (variable.isSet) {
      console.log(`%c${key}: %c${variable.preview}`, 
        'font-weight: bold',
        variable.isPlaceholder ? 'color: orange; font-weight: bold' : 'color: green; font-weight: bold'
      );
    } else {
      console.log(`%c${key}: %cNot set`, 'font-weight: bold', 'color: red; font-weight: bold');
    }
  });
  
  if (results.issues.length > 0) {
    console.group('Issues Found');
    results.issues.forEach(issue => {
      console.warn(`[WARNING] ${issue}`);
    });
    console.groupEnd();
  } else {
    console.log('%cAll environment variables are properly configured!', 'color: green; font-weight: bold');
  }
  
  console.groupEnd();
  
  return results;
};

export default {
  checkEnvironmentVariables,
  logEnvironmentStatus
};
